<template>
  <HeaderCustom title="Gestão do Conhecimento">
    <v-row class="ma-0 align-end justify-space-between">
      <v-col cols="6" class="pb-0 ps-0">
        <v-card-title class="px-0 pb-0">
          <v-btn icon @click="router.push('/legislacao/consulta')">
            <v-icon>
              {{ mdiArrowLeft }}
            </v-icon>
          </v-btn>
          Legislação
        </v-card-title>
      </v-col>
      <SeletorOpcoesImpressão
        :items="itensImpressao"
        @change="store.infoGeraisDownload"
      />
    </v-row>
    <v-row class="mt-0">
      <v-col>
        <CardInformacoesGerais />
      </v-col>
    </v-row>
  </HeaderCustom>
</template>

<script lang="ts" setup>
import CardInformacoesGerais from './components/consulta/CardInformacoesGerais.vue';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import { mdiArrowLeft } from '@mdi/js';
import router from '@/router';

import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import HeaderCustom from '../components/HeaderCustom.vue';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';

const store = ConsultaLegislacaoStore();

const itensImpressao = [
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
  {
    text: 'Texto da norma',
    value: 'T',
    icone: IconTextoNorma,
  },
];
</script>
